<template>
    <section class="table-responsive">
        <div class="heatmap-table">
            <span class="trow">
                <span class="tcolumn"></span>
                <span v-for="head in labelsX" class="tcolumn">
                    {{head}}
                </span>
            </span>
            <span v-for="row in labelsY" class="trow">
                <span class="tcolumn">
                    {{row.name}}
                </span>
                <span v-for="i in matrix[row.id]" class="tcolumn data" :style="{'background-color': color(i)}">

                </span>
            </span>
        </div>
    </section>
</template>

<script>
    import {flatten, min, max} from 'lodash'

    export default {
        name: 'Heatmap',
        props: ['data'],
        data () {
            return {
                matrix: [],
                labelsX: [],
                labelsY: [],
                min: 0,
                max: 0
            }
        },
        watch: {
            data (data) {
                this.matrix = data.data
                this.labelsX = data.labels.x
                let i = 0
                this.labelsY = data.labels.y.map(x => { return {id: i++, name: x} })
                const flattened = flatten(this.matrix)
                this.max = max(flattened)
                this.min = min(flattened)
            }
        },
        methods: {
            color (value) {
                // 50, 94.9, 92,4
                // 228, 70.9, 20.2
                if (this.max - this.min === 0) {
                    return 'hsl(136 ,60%, 57%)'
                }
                const h = 136 - Math.floor((((value - this.min) / (this.max - this.min))) * 136)
                return `hsl(${h} ,60%, 57%)`
            }
        }
    }
</script>

<style scoped lang="scss">
    .heatmap-table {
        display: table;
        width: 100%;
        height: 100%;
        .trow {
            display: table-row;

            .tcolumn {
                font-size: 12px;
                padding: 2px 2px;
                display: table-cell;

                &.data {
                    border: 1px solid white;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Heatmap.vue